import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MtnaSearchBoxModule } from '@mtna/core-angular';

import { RdsCodeSelectComponent } from './code-select.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatListModule,
    MatPaginatorModule,
    MatRadioModule,
    MatTooltipModule,
    MtnaSearchBoxModule,
    ScrollingModule,
  ],
  declarations: [RdsCodeSelectComponent],
  exports: [RdsCodeSelectComponent],
})
export class RdsCodeSelectModule {}

export * from './code-select.component';
